"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsWarningIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _DmsLogViewer = require("./DmsLogViewer");
var _WarningAmber = _interopRequireDefault(require("@mui/icons-material/WarningAmber"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _Log = require("../../constants/Log");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsWarningIcon = () => /*#__PURE__*/_react.default.createElement(_DmsLogViewer.DmsLogViewer, {
  icon: /*#__PURE__*/_react.default.createElement(_WarningAmber.default, null),
  modalTitle: _reactIntlUniversal.default.get("WarningLogs").d("Warning Logs"),
  logLevel: _Log.LogLevel.WARNING
});
exports.DmsWarningIcon = DmsWarningIcon;